import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ImageViewerItem {
  src: string;
  title?: string;
}

export interface ImageViewerRequest {
  images: ImageViewerItem[];
  startIndex: number;
}

@Injectable({ providedIn: 'root' })
export class ImageViewerService {
  private openSubject = new Subject<ImageViewerRequest>();
  open$ = this.openSubject.asObservable();

  open(images: ImageViewerItem[], startIndex = 0): void {
    this.openSubject.next({ images, startIndex });
  }

  openSingle(src: string, title?: string): void {
    this.open([{ src, title }], 0);
  }
}
